import React, { useMemo } from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import MdiIcon from '@mdi/react';
import {
  iconList,
  iconListPeople,
  iconListJobsRoles,
  iconListCommunication,
  iconListVehicles,
  iconListPlaces,
  iconListObjects,
  iconListIcons,
  iconListAnimals,
  iconListFoodDrink,
} from './RoleIconList';

const useStyles = makeStyles(() =>
  createStyles({
    select: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '20px',
    },
    list: {
      '& li': {
        display: 'inline-block',
      },
    },
    paper: {
      width: '400px',
      height: '300px',
      overflowY: 'auto',
    },
  })
);

const ICON_GROUPS: Array<{ label: string; icons: Record<string, string> }> = [
  { label: 'People', icons: iconListPeople },
  { label: 'Jobs & Roles', icons: iconListJobsRoles },
  { label: 'Communication', icons: iconListCommunication },
  { label: 'Vehicles', icons: iconListVehicles },
  { label: 'Places', icons: iconListPlaces },
  { label: 'Objects', icons: iconListObjects },
  { label: 'Icons', icons: iconListIcons },
  { label: 'Animals', icons: iconListAnimals },
  { label: 'Food & Drink', icons: iconListFoodDrink },
];

interface IconPickerSelectProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  id?: string;
}

const IconPickerSelect = (props: IconPickerSelectProps) => {
  const { value, onChange, label = 'Icon', id = 'icon-picker' } = props;
  const classes = useStyles();

  const iconOptions = useMemo(() => {
    const items: React.ReactNode[] = [];
    ICON_GROUPS.forEach((group) => {
      items.push(
        <small key={`label-${group.label}`} style={{ paddingLeft: 15, paddingTop: 10, paddingBottom: 5 }}>
          {group.label}
        </small>
      );
      Object.entries(group.icons).forEach(([key, path]) => {
        items.push(
          <MenuItem key={key} value={key}>
            <MdiIcon path={path} size={1} />
          </MenuItem>
        );
      });
    });
    return items;
  }, []);

  return (
    <FormControl variant='outlined' style={{ minWidth: 120 }}>
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value as string)}
        label={label}
        inputProps={{ name: 'icon', id }}
        classes={{ select: classes.select }}
        renderValue={(val) => (
          <Box display='flex' alignItems='center'>
            {iconList[val as string] ? <MdiIcon path={iconList[val as string]} size={1} /> : 'Select'}
          </Box>
        )}
        MenuProps={{
          classes: { list: classes.list, paper: classes.paper },
          anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
          transformOrigin: { vertical: 'top', horizontal: 'center' },
          getContentAnchorEl: null,
        }}
      >
        {iconOptions}
      </Select>
    </FormControl>
  );
};

export { IconPickerSelect };
